export const generateUrl = (data: string, type = 'text/csv;charset=utf-8;'): string => URL.createObjectURL(new Blob([data], { type }));
